import { MONTHS_ABBREVIATIONS } from "../configurations/Constants";

const DateHelper = {
  getDate(date, format) {
    try {
      const day = date.getDate();
      const year = date.getFullYear();
      const month = MONTHS_ABBREVIATIONS[date.getMonth()];
      let convertedDate = `${day} ${month} ${year}`;
      if (format === "MMM dd YYYY") {
        convertedDate = `${month} ${day} ${year}`;
      }
      return convertedDate;
    } catch (error) {
      return error;
    }
  },
};
export default DateHelper;
